module.exports = __webpack_public_path__ + "img/area-chart-spline-dark-01.1fadb12a.jpg";